// src/components/ui/ErrorBoundary.tsx

import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

/**
 * 全局错误边界组件
 */
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-4">
          <div className="max-w-md text-center">
            <h1 className="text-xl font-bold text-red-600 mb-4">应用发生错误</h1>
            <p className="text-gray-600 mb-6">
              {this.state.error?.message || '未知错误'}
            </p>
            <Button type="primary" onClick={() => window.location.reload()}>
              刷新页面
            </Button>
            <div className="mt-4">
              <Link to="/" className="text-blue-600 hover:text-blue-800">
                返回首页
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}